import { images } from '@/asset';
import BoldSmallText from '@/components/BoldSmallText';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { Card, InlineStack, Text } from '@shopify/polaris';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import BaseImage from '../Icons/BaseImage';
import { PreviewStyled } from './styled';

interface IProps {
  children?: any;
  top: number;
  labelText: string;
  isShowShippingMethodName: boolean;
}

const PreviewProductLineItems = ({ top, labelText, isShowShippingMethodName }: IProps) => {
  const dataSettings = useSelector(dataSettingsSelector);

  return (
    <PreviewStyled top={top} generalSetting={dataSettings}>
      <Card padding={'0'}>
        <div className="preview-header">
          <Text as="span" variant="bodyMd">
            CHECKOUT PREVIEW
          </Text>
        </div>
        <div className="preview-content">
          <InlineStack gap={'300'} wrap={false}>
            <BaseImage style={{ width: '64px', height: '64px' }} src={images.product} alt="preview" />
            <div className="d-flex">
              <div className="d-flex flex-column ">
                <BoldSmallText>Ceramic vase</BoldSmallText>
                <Text as="p" tone="subdued" variant="bodyLg">
                  {labelText}: {isShowShippingMethodName ? 'Standard - ' : ''}6 Jun to 8 Jun
                </Text>
                <Text as="span" tone="text-inverse">
                  $68.00
                </Text>
              </div>
            </div>
          </InlineStack>
        </div>
      </Card>
    </PreviewStyled>
  );
};

export default memo(PreviewProductLineItems);
